import { toggleNav } from '../js/main'
import '../css/reset.css'
import '../css/constants.css'
import '../css/main.css'
import './industries-served-and-applications.css'
toggleNav()
console.log('this is about page');